import { createFileRoute } from "@tanstack/react-router";

import { DataDeletionPage } from "@/components/marketing/data-deletion-page";
import { pageHead } from "@/lib/seo";

export const Route = createFileRoute("/(public)/data-deletion")({
  head: () => pageHead("dataDeletion"),
  component: DataDeletionPage,
});
